import { useDispatch } from '@store';
import { useCallback } from 'react';
import {
  initDocuments,
  updateDocumentsOptions,
  DocumentsOptions,
  updateDocumentsCurrentId,
  initDocumentsCurrentId,
  DocumentsCurrentId
} from '@modules/documents';

const useDocuments = () => {
  const dispatch = useDispatch();

  const onInitDocuments = useCallback(() => dispatch(initDocuments()), [
    dispatch
  ]);

  const onInitDocumentsCurrentId = useCallback(
    () => dispatch(initDocumentsCurrentId()),
    [dispatch]
  );

  const onUpdateDocumentsCurrentId = useCallback(
    (payload: DocumentsCurrentId) =>
      dispatch(updateDocumentsCurrentId(payload)),
    [dispatch]
  );

  const onUpdateDocumentsOptions = useCallback(
    (payload: DocumentsOptions) => dispatch(updateDocumentsOptions(payload)),
    [dispatch]
  );

  return {
    onInitDocuments,
    onInitDocumentsCurrentId,
    onUpdateDocumentsCurrentId,
    onUpdateDocumentsOptions
  };
};

export default useDocuments;
